// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3TleU","icon":"style_icon__O9cCz","title":"style_title__DE_EI"};